import request from "./request"

const path = "dj.api."

// 内容管理列表查询条件可见门店列表
export function getMerchantList(data) {
  data.method = `dj.smartcarlife.api.shopMerchant.list`
  return request(data)
}
// 内容管理列表查询
export function getContenttList(data) {
  data.method = `${path}material.record.page`
  return request(data)
}
// 内容管理详情
export function getContentDetail(data) {
  data.method = `${path}material.record.detail`
  return request(data)
}
// 批量启停用内容
export function batchOperaterContent(data) {
  data.method = `${path}material.record.batch.operate`
  return request(data)
}
// 删除内容
export function delContent(data) {
  data.method = `${path}material.record.delete`
  return request(data)
}
// 统计列表
export function getStatisticsList(data) {
  data.method = `dj.api.customer.dynamic.record.page`
  return request(data)
}
// 导出统计列表
export function exportStatisticsList(data) {
  data.method = `dj.api.customer.dynamic.record.page.export`
  return request(data)
}
// 新增内容
export function addContent(data) {
  data.method = `${path}material.record.add`
  return request(data, "post")
}
// 编辑内容
export function updateContent(data) {
  data.method = `${path}material.record.update`
  return request(data, "post")
}

// 获取会员权益/升级和积分商城 门店
export function getAllMerchantList(data) {
  data.method = `dj.api.merchant.page`
  return request(data, "POST")
}

// 获取精品升级/次新车转化/售后众筹 门店
export function getMerchantListByScene(data) {
  data.method = `dj.api.scenemerchantref.listShop4sByRef.page`
  return request(data)
}
// 获取精品升级/次新车转化/售后众筹 门店
export function getListShop4sByRef(data) {
  data.method = `dj.api.scenemerchantref.listShop4sByRef`
  return request(data)
}
// 获取品牌列表
export function getBrandList(data) {
  data.method = `dj.api.smartcarlife.common.car.brand.page`
  return request(data)
}

// 分页查询标签员工
export function getListLabelStaffPage(data) {
  data.method = `dj.api.smartcarlife.contentManagerTask.listLabelStaffPage`
  return request(data)
}

// 员工群发-分页查询列表
export function contentManagerTaskPage(data) {
  data.method = `dj.api.smartcarlife.contentManagerTask.page`
  return request(data, "POST")
}

// 员工群发-删除记录
export function deleteTaskById(data) {
  data.method = `dj.api.smartcarlife.contentManagerTask.deleteById`
  return request(data, "POST")
}

// 员工群发-分页查询内容管理统计信息
export function getStatisticPage(data) {
  data.method = `dj.api.smartcarlife.contentManagerTask.statistic.page`
  return request(data, "POST")
}

// 员工群发-添加/修改记录
export function insertOrUpdate(data) {
  data.method = `dj.api.smartcarlife.contentManagerTask.insertOrUpdate`
  return request(data, "POST")
}

// 根据ID查询详细信息
export function contentManagerTaskById(data) {
  data.method = `dj.api.smartcarlife.contentManagerTask.getById`
  return request(data, "POST")
}

// 获取接待场景
export function receptionSceneList(data) {
  data.method = "dj.api.material.reception.scene.list"
  return request(data, "POST")
}

// 获取客户标签树
export function getLabelList(data) {
  data.method = "dj.api.material.customer.label.list"
  return request(data, "POST")
}

// 单一商品
export function listAllInWithPage(data) {
  data.method = "dj.api.smartcarlife.upgradeGoods.listAllInWithPage"
  return request(data, "POST")
}

// 套餐商品
export function allInPage(data) {
  data.method = "dj.api.smartcarlife.merchantPackageGoodsInfo.allInPage"
  return request(data, "POST")
}

// 获取产品词条列表
export function productTextPage(data) {
  data.method = "dj.api.material.product.text.page"
  return request(data, "POST")
}

// 分页获取产品词条列表
export function productPage(data) {
  data.method = `dj.api.material.product.text.page`
  return request(data, "POST")
}
// 获取产品词条详情
export function productDetail(data) {
  data.method = `dj.api.material.product.text.detail`
  return request(data, "POST")
}
// 删除产品词条
export function productDelete(data) {
  data.method = `dj.api.material.product.text.delete`
  return request(data, "POST")
}

// 保存产品词条
export function productSave(data) {
  data.method = `dj.api.material.product.text.save`
  return request(data, "POST")
}
// 更新产品词条
export function productUpdate(data) {
  data.method = `dj.api.material.product.text.update`
  return request(data, "POST")
}

// 查询接待素材商户配置
export function materialPage(data) {
  data.method = `dj.api.smartcarlife.recepiton.material.page`
  return request(data, "post", [], "", "/rop-dj-car-boutique/router")
}

// 查询门店接待素材详情
export function materialDetail(data) {
  data.method = `dj.api.smartcarlife.recepiton.material.merchant.detail`
  return request(data, "post", [], "", "/rop-dj-car-boutique/router")
}
// 获取车系列表
export function listBrandWithSeries(data) {
  data.method = `dj.api.smartcarlife.merchantbrandmodel.listBrandWithSeries`
  return request(data, "post")
}

// 保存更新门店接待素材
export function recepitonUpdate(data) {
  data.method = `dj.api.smartcarlife.recepiton.material.merchant.saveOrUpdate`
  return request(data, "post", [], "", "/rop-dj-car-boutique/router")
}
// 保存更新门店接待素材
export function findDictData(data) {
  data.method = `merchants.api.menu.findDictData`
  return request(data, "post")
}

// 保存更新门店接待素材
export function deleteDictData(data) {
  data.method = `merchants.api.menu.deleteDictData`
  return request(data, "post")
}
// 保存更新门店接待素材
export function updateDictData(data) {
  data.method = `merchants.api.menu.updateDictData`
  return request(data, "post")
}
// 保存更新门店接待素材
export function saveDictData(data) {
  data.method = `merchants.api.menu.saveDictData`
  return request(data, "post")
}
/**客户标签列表 */
export function getCustomerLabelPage(data) {
  data.method = `dj.api.material.customer.label.page`
  return request(data, "post")
}
/**新增客户标签 */
export function addCustomerLabel(data) {
  data.method = `dj.api.material.customer.label.add`
  return request(data, "post")
}

/**修改客户标签 */
export function updateCustomerLabel(data) {
  data.method = `dj.api.material.customer.label.update`
  return request(data, "post")
}
/**分页查询客户档案信息(管理后台) */
export function getCustomerFilePage(data) {
  data.method = `dj.api.mindworkplate.customervisit.customerInfoListPage`
  return request(data, "post")
}

/**客户档案信息(管理后台)导出 */
export function exportCustomerFile(data) {
  data.method = `dj.api.mindworkplate.customervisit.customerInfoListExport`
  return request(data, "post")
}

/** 客户档案统计信息(管理后台) */
export function getCustomerFileStatic(data) {
  data.method = `dj.api.mindworkplate.customervisit.customerInfoListStatic`
  return request(data, "post")
}
/** 客户档案话术浏览记录 */
export function getCustomerVisitScriptsListPage(data) {
  data.method = `dj.api.mindworkplate.customervisit.CustomerVisitScriptsListPage`
  return request(data, "post")
}

/**客户档案标签 */
export function getCustomerInfoDetail(data) {
  data.method = `dj.api.mindworkplate.customervisit.getCustomerInfoDetail`
  return request(data, "post")
}
